export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Analyse IA du dépôt de plainte"])},
        "not_analyzed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dépôt de plainte pas encore analysé."])},
        "retry_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Relancer l'analyse"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI analysis of the police report"])},
        "not_analyzed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Police report not yet analyzed."])},
        "retry_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retry analysis"])}
      }
    }
  })
}
